import React from 'react';
import Icon from '../../../components/AppIcon';

const AchievementBadge = ({ badge }) => {
  const getCategory = (criteria) => {
    const type = criteria?.type;
    if (type === 'proof_count' || type === 'proof_edit_count' || type === 'night_proof_count' || type === 'morning_proof_count') return '증명';
    if (type === 'streak_days') return '연속';
    if (type === 'five_star_count' || type === 'avg_star_gte') return '별점';
    if (type === 'project_count') return '프로젝트';
    if (type === 'public_proof_count' || type === 'private_proof_count') return '공개';
    if (type === 'active_months') return '활동';
    if (type === 'completed_challenge_count') return '완주';
    if (type === 'like_given_count' || type === 'like_received_count') return '추천';
    if (type === 'destime_entry_count' || type === 'destime_total_minutes' || type === 'destime_active_days') return '데스타임';
    return '기타';
  };

  const getConditionText = (criteria) => {
    const type = criteria?.type;
    const threshold = criteria?.threshold;

    if (type === 'proof_count') return `증명 ${threshold}개 제출`;
    if (type === 'project_count') return `프로젝트 ${threshold}개 생성`;
    if (type === 'completed_challenge_count') return `챌린지 ${threshold}개 완료`;
    if (type === 'five_star_count') return `별 5개 증명 ${threshold}회`;
    if (type === 'avg_star_gte') return `평균 별점 ${Number(threshold).toFixed(1)} 이상`;
    if (type === 'streak_days') return `${threshold}일 연속 증명 제출`;
    if (type === 'public_proof_count') return `공개 증명 ${threshold}개`;
    if (type === 'private_proof_count') return `비공개 증명 ${threshold}개`;
    if (type === 'active_months') return `서로 다른 ${threshold}개월에 활동`;
    if (type === 'proof_edit_count') return `증명 수정 ${threshold}회`;
    if (type === 'night_proof_count') return `밤(21~03시) 증명 ${threshold}회`;
    if (type === 'morning_proof_count') return `아침(05~09시) 증명 ${threshold}회`;
    if (type === 'like_given_count') return `좋아요 ${threshold}회 누르기`;
    if (type === 'like_received_count') return `좋아요 ${threshold}회 받기`;

    if (type === 'destime_entry_count') return `데스타임 ${threshold}회 기록`;
    if (type === 'destime_total_minutes') return `데스타임 ${threshold}분 누적`;
    if (type === 'destime_active_days') return `데스타임 ${threshold}일 기록`;

    return '조건 정보 없음';
  };

  return (
    <div className="bg-card rounded-lg shadow-gaming-md p-4 md:p-5 transition-gaming hover:shadow-gaming-lg">
      <div className="flex items-start space-x-3 md:space-x-4">
        <div className={`flex-shrink-0 w-12 h-12 md:w-14 md:h-14 rounded-md flex items-center justify-center ${
          badge?.unlocked ? 'bg-accent/20' : 'bg-muted/50'
        }`}>
          <Icon
            name={badge?.icon}
            size={24}
            color={badge?.unlocked ? 'var(--color-accent)' : 'var(--color-muted-foreground)'}
            className="md:w-7 md:h-7"
          />
        </div>
        <div className="flex-1 min-w-0">
          <h4 className={`text-sm md:text-base font-heading font-semibold mb-1 ${
            badge?.unlocked ? 'text-foreground' : 'text-muted-foreground'
          }`}>
            {badge?.name}
          </h4>
          <p className="text-xs md:text-sm text-muted-foreground caption line-clamp-2">
            {badge?.description}
          </p>

          <div className="flex items-center flex-wrap gap-2 mt-2">
            <span className="text-[11px] px-2 py-1 rounded-md bg-muted/50 text-muted-foreground caption">
              {getCategory(badge?.criteria)}
            </span>
            <span className="text-[11px] px-2 py-1 rounded-md bg-primary/10 text-primary caption">
              획득 조건: {getConditionText(badge?.criteria)}
            </span>
          </div>

          {badge?.unlocked && badge?.unlockedAt && (
            <p className="text-xs text-success mt-2 caption">
              {new Date(badge.unlockedAt)?.toLocaleDateString('ko-KR')} 획득
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default AchievementBadge;